import { render, staticRenderFns } from "./coverage.vue?vue&type=template&id=dd0ac3f2&scoped=true&"
import script from "./coverage.vue?vue&type=script&lang=js&"
export * from "./coverage.vue?vue&type=script&lang=js&"
import style0 from "./coverage.vue?vue&type=style&index=0&id=dd0ac3f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0ac3f2",
  null
  
)

export default component.exports